import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Dialog } from 'components';

const AnimatedDialog = (props: any) => {
  const { isOpen, children, ...dialogProps } = props;

  return (
    <Dialog 
      {...dialogProps} 
      isOpen={isOpen}
      sx={{
        '.MuiBackdrop-root': {
          opacity: '0 !important',
          animation: 'backdrop-fade-in 0.2s ease-out forwards',
        },
        '.MuiPaper-root': {
          transform: 'scale(0.95) translateY(20px)',
          opacity: 0,
          animation: 'dialog-slide-in 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) forwards',
          borderRadius: '12px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
        },
        '@keyframes backdrop-fade-in': {
          '0%': { opacity: 0 },
          '100%': { opacity: 1 },
        },
        '@keyframes dialog-slide-in': {
          '0%': { 
            transform: 'scale(0.95) translateY(20px)',
            opacity: 0,
          },
          '100%': { 
            transform: 'scale(1) translateY(0)',
            opacity: 1,
          },
        },
        ...dialogProps.sx,
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ 
          delay: 0.1,
          duration: 0.2,
          ease: "easeOut"
        }}
      >
        {children}
      </motion.div>
    </Dialog>
  );
};

export default AnimatedDialog;